import React, { useState } from 'react';
import { useLanguage } from '../../helpers/language-context';

const locationsData = [
  {
    id: 'shah-alam',
    title: {
      en: 'Shah Alam Headquarters',
      ms: 'Ibu Pejabat Shah Alam'
    },
    address: 'Aras LPH, Menara Bank Rakyat Shah Alam, No. 1 Jalan Indah 14/8, Seksyen 14, 40000 Shah Alam, Selangor Darul Ehsan',
    phone: '+603-55187735',
    fax: '+603-55187735',
    email: 'info@semesta.com.my',
    mapQuery: 'Menara Bank Rakyat Shah Alam'
  },
  {
    id: 'northern',
    title: {
      en: 'Northern Office',
      ms: 'Pejabat Wilayah Utara'
    },
    address: 'No. 6-1 & 8-1 Jalan Aman Suria 1, Taman Aman Suria, 45600 Bestari Jaya, Selangor Darul Ehsan',
    phone: '+603-87680334',
    email: 'info@semesta.com.my',
    mapQuery: 'Jalan Aman Suria 1, Taman Aman Suria, Bestari Jaya'
  },
  {
    id: 'southern',
    title: {
      en: 'Southern Office',
      ms: 'Pejabat Wilayah Selatan'
    },
    address: 'No. 17 Tingkat Bawah, Jalan Ambar 1, Taman Ambar, 43800 Dengkil, Selangor Darul Ehsan',
    email: 'info@semesta.com.my',
    mapQuery: 'Jalan Ambar 1, Taman Ambar, Dengkil'
  }
];

const Locations = () => {
  const { language } = useLanguage();
  const [selectedId, setSelectedId] = useState('shah-alam');

  const selectedLocation = locationsData.find(loc => loc.id === selectedId);

  return (
    <div className="flex flex-col w-full">
      {/* Top Section */}
      <section className="bg-[#28357B] text-white relative">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
        {locationsData.map((location) => {
            const isSelected = selectedId === location.id;
            const title = location.title[language] || location.title['en'];
            
            return (
            <div
                key={location.id}
                className={`cursor-pointer transition-all duration-300 relative flex flex-col h-full group ${isSelected ? 'opacity-100' : 'opacity-50 hover:opacity-80'}`}
                onClick={() => setSelectedId(location.id)}
            >
                {/* Icon */}
                <div className="mb-6">
                    <svg className="w-10 h-10 text-[#FBB040]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                </div>

                <h3 className="text-2xl font-semibold mb-4 tracking-wide">{title}</h3>
                <p className="mb-8 text-sm leading-relaxed text-gray-200">{location.address}</p>

                <div className="space-y-4 mt-auto">
                {location.phone && (
                    <div className="flex items-center gap-3 text-sm text-gray-200">
                    <svg className="w-5 h-5 text-[#FBB040]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                    <span>{location.phone}</span>
                    </div>
                )}
                {location.fax && (
                    <div className="flex items-center gap-3 text-sm text-gray-200">
                    <svg className="w-5 h-5 text-[#FBB040]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                    </svg>
                    <span>{location.fax}</span>
                    </div>
                )}
                {location.email && (
                    <div className="flex items-center gap-3 text-sm text-gray-200">
                        <svg className="w-5 h-5 text-[#FBB040]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                        <a href={`mailto:${location.email}`} className="hover:text-white transition-colors">{location.email}</a>
                    </div>
                )}
                </div>
                
                {/* Triangle Indicator */}
                {isSelected && (
                <div className="maps-triangle-indicator absolute -bottom-[80px] left-0 w-0 h-0 border-l-[25px] border-l-transparent border-r-[25px] border-r-transparent border-b-[25px] border-b-white z-10 hidden lg:block"></div>
                )}
            </div>
            );
        })}
        </div>
      </section>

      {/* Map Section */}
      <section className="maps-section h-[600px] w-full">
         <iframe
           key={selectedId}
           width="100%"
           height="100%"
           frameBorder="0"
           scrolling="no"
           marginHeight="0"
           marginWidth="0"
           src={`https://maps.google.com/maps?q=${encodeURIComponent(selectedLocation.mapQuery)}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
           title={selectedLocation.title[language] || selectedLocation.title['en']}
           className="w-full h-full filter grayscale-[20%] hover:grayscale-0 transition-all duration-500"
         ></iframe>
      </section>
    </div>
  );
};

export default Locations;
